import React, {Component} from 'react';
import './changePassword.scss'
export default class changePassword extends Component {
  render() {    
    return (
      <div className="page-change-password">
        Hello change password
      </div>
    )
  }
}